<template>
    <span class="d-flex align-items-center">
        <span v-if="request.id" class="text-nowrap">
            <b-icon icon="circle-fill" font-scale="0.7" :variant="requestStatusVariant" class="mr-1"/>
            <small class="text-secondary">{{ statusName }}</small>
        </span>
    </span>
</template>

<script>
import {RequestStatus} from "@/pages/AppPages/Requests/request";

export default {
    name: "RequestStatusIndicator",
    props: {
        request: { type: Object, default: () => { return {} } }
    },
    computed: {
        status() {
            if (this.request.descriptionObject) {
                return this.request.status
            }
            if (this.request['description_object']) {
                return this.request['description_object']['status']
            }
            return null
        },
        statusName() {
            if (this.request.descriptionObject) {
                return this.request.statusName
            }
            if (this.request['description_object']) {
                return this.request['description_object']['status_name']
            }
            return null
        },
        requestStatusVariant() {
            switch (this.status) {
                case RequestStatus.OPEN: return 'warning';
                case RequestStatus.ASSIGNED: return 'info';
                case RequestStatus.WIP: return 'primary';
                case RequestStatus.DONE: return 'success';
                case RequestStatus.CANCELLED: return 'danger';
                default: return 'secondary'
            }
        },

    }
}
</script>

<style scoped>

</style>